<script lang="ts" setup>
import FillLockIcon from '@/components/common/icons/FillLockIcon.vue'
import { UIBadge } from '@gohighlevel/ghl-ui'
import { PropType, computed, defineProps } from 'vue'
import { useRoute } from 'vue-router'
import { getChannelIcon, isChannelIconEmoji } from '../helper'

const route = useRoute()
const props = defineProps({
  channel: {
    type: Object,
    required: true,
  },
  iconSize: {
    type: Number,
    default: 24,
  },
  emojiSize: {
    type: Number,
    default: 24,
  },
  lockIconSize: {
    type: String,
    default: 'h-4 w-4',
  },
  lockIconPosition: {
    type: Object as PropType<{ top: number; right: number }>,
    default: () => ({ top: 2, right: -16 }),
  },
  lockIconEmojiPosition: {
    type: Object as PropType<{ top: number; right: number }>,
    default: () => ({ top: 4, right: -16 }),
  },
  lockIconFill: {
    type: String,
    default: 'var(--fontPrimary)',
  },
  lockIconCss: {
    type: String,
    default: 'bg-transparent',
  },
  showingInSidebar: {
    type: Boolean,
    default: false,
  },
  showingInMobileDrawer: {
    type: Boolean,
    default: false,
  },
  showLockIcon: {
    type: Boolean,
    default: true,
  },
})

const offsetRight = computed(() => {
  if (isChannelIconEmoji(props.channel.icon)) {
    return props.lockIconEmojiPosition.right
  } else {
    return props.lockIconPosition.right
  }
})

const offsetTop = computed(() => {
  if (isChannelIconEmoji(props.channel.icon)) {
    return props.lockIconEmojiPosition.top
  } else {
    return props.lockIconPosition.top
  }
})
</script>
<template>
  <UIBadge
    :id="'avatar-badge'"
    class="custom-badge-sup"
    :offset="[offsetRight, offsetTop]"
    :color="'bg - transparent'"
    :show="channel.visibility === 'PRIVATE'"
  >
    <template #content>
      <div
        v-if="isChannelIconEmoji(channel.icon)"
        :class="
          showingInMobileDrawer
            ? `text-communities-selected-item-font `
            : route?.params?.channelSlug == channel.slug && showingInSidebar
            ? `text-communities-sidebar-selected-item-font `
            : `text-communities-sidebar-font-primary `
        "
      >
        <span
          :class="`leading-tight`"
          :style="{ 'font-size': emojiSize + 'px' }"
          >{{ props.channel.icon }}</span
        >
      </div>
      <component
        :is="getChannelIcon(props.channel?.icon)"
        v-else
        :class="
          showingInMobileDrawer
            ? `h-[${iconSize}px] w-[${iconSize}px] text-communities-selected-item-font`
            : route?.params?.channelSlug == channel.slug && showingInSidebar
            ? `h-[${iconSize}px] w-[${iconSize}px] text-communities-sidebar-selected-item-font`
            : `h-[${iconSize}px] w-[${iconSize}px] text-communities-sidebar-font-primary`
        "
      />
    </template>
    <template #value>
      <FillLockIcon
        v-if="showLockIcon"
        :class="`${props.lockIconCss} ${props.lockIconSize}`"
        :fill="lockIconFill"
      />
    </template>
  </UIBadge>
</template>
